import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '@shared/components';
import { ButtonModule } from 'primeng/button';
import { DashboardService } from '../../_core/services/dashboard.service';

@Component({
    selector: 'app-courier-information-section',
    standalone: true,
    imports: [ButtonModule, TranslateModule, LoaderComponent],
    templateUrl: './courier-information-section.component.html',
    styleUrls: ['./courier-information-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourierInformationSectionComponent {
    readonly isLoading = input(false);
    readonly onOpenScheduleCourierPickUp = output();

    readonly courierPickupDetails = computed(() => this.dashboardService.dashboardData().courierPickupDetails);

    constructor(private dashboardService: DashboardService) {}
}
